// extracted by mini-css-extract-plugin
export default {"wrapper":"HE-z","viewport":"IE-z","container":"JE-z","slide":"KE-z"};